import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { InputGroup, Form } from "react-bootstrap";
import { UsdDonateWrapper } from "./UsdDonateStyle";
import { MESSAGE } from "../../../utils/message";

interface Props {
  value: number | string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
}

const CustomUsdField = ({ value, onChange, onBlur }: Props) => {
  return (
    <UsdDonateWrapper className="CH">
      <InputGroup>
        <InputGroup.Text className="inputicon">$</InputGroup.Text>
        <Form.Control
          className="inputbox"
          type="number"
          onKeyDown={(evt) =>
            ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
          }
          placeholder="Enter Here"
          id="amount"
          aria-label="Enter Here"
          name="amount"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
        <InputGroup.Text className="inputtext">{MESSAGE.usd}</InputGroup.Text>
      </InputGroup>
    </UsdDonateWrapper>
  );
};

export default CustomUsdField;
